import { createFileRoute } from '@tanstack/react-router'
import BundleContainerList from 'Bundle/containers/BundleContainerList'
import { claimTypesEnum } from 'User/utils/claims'
import { Suspense } from 'react'

import PrivateRoute from 'Common/components/router/PrivateRoute'
import { PageSkeleton } from 'Common/components/skeletons'
import { useAuth } from 'Common/utils/query/useAuth'

export const Route = createFileRoute('/bundle/list')({
    component: BundleList,
})

function BundleList() {
    const auth = useAuth()

    return (
        <PrivateRoute auth={auth} restrictToClaims={[claimTypesEnum.enum.opus_work]}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="main" />}>
                <BundleContainerList />
            </Suspense>
        </PrivateRoute>
    )
}
